import isWebview from 'is-ua-webview';
import logo from './logo.svg';
import './App.css';

function App() {
  debugger;
  const webview = isWebview(navigator.userAgent);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          {webview ? "isWebview" : "Browser"}
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
